export interface GetImageUrl {
  additionalParam?: string;
  fallbackImage?: string;
  src: string;
  staticAssetsUrl: string;
}

export const getImageUrl = ({
  additionalParam = '',
  fallbackImage,
  src,
  staticAssetsUrl,
}: GetImageUrl): string | undefined => {
  if (src) {
    return src.includes(staticAssetsUrl) ? src : `${src}${additionalParam}`;
  }
  return fallbackImage;
};
